import { isEmpty } from "lodash";
import { Network } from "../../network";
import { NFT, NFTOwnership } from "../nft";
export const MORALIS_SUPPORTED_EVM_NETWORKS = [
    Network.ETHEREUM,
    Network.POLYGON,
    Network.BSC,
    Network.AVALANCHE,
    Network.FANTOM,
    Network.CRONOS,
    Network.ETHEREUM_GOERLI,
    Network.POLYGON_MUMBAI,
];
export const moralisAssetToNFT = (network, asset, owner) => {
    let metadata = {};
    try {
        if (asset.metadata)
            metadata = JSON.parse(asset.metadata);
    }
    catch (error) { }
    return new NFT({
        network,
        owners: [{ address: owner, quantity: 1 }],
        name: metadata.name || asset.name,
        collectionId: asset.token_address,
        tokenId: asset.token_id,
        imageUrl: metadata.image
            ? metadata.image.replace("ipfs://", "https://ipfs.io/ipfs/")
            : "",
        attributes: !isEmpty(metadata)
            ? metadata.attributes.map((attribute) => ({
                traitType: attribute.trait_type,
                value: attribute.value,
            }))
            : [],
        animationUrl: metadata.animation_url,
    });
};
export const moralisAssetToNFTOwnership = (network, asset, owner) => {
    var _a;
    let metadata = {};
    try {
        if (asset.metadata)
            metadata = JSON.parse(asset.metadata);
    }
    catch (error) { }
    return new NFTOwnership({
        network,
        standard: asset.contract_type,
        owner,
        collectionId: asset.token_address,
        tokenId: asset.token_id,
        quantity: parseInt(asset.amount),
        attributes: !isEmpty(metadata)
            ? (_a = metadata.attributes) === null || _a === void 0 ? void 0 : _a.map((attribute) => ({
                traitType: attribute.trait_type,
                value: attribute.value,
            }))
            : [],
    });
};
export const moralisSolanaAssetToNFT = (network, asset, owner) => {
    return new NFT({
        network,
        owners: [{ address: owner, quantity: 1 }],
        collectionId: "",
        tokenId: asset.mint,
    });
};
